import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelPlanSlice = createSlice({
  name: "getTravelPlan",
  initialState,
  reducers: {
    getTravelPlanStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelPlanSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelPlanFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelPlanStart,
  getTravelPlanSuccess,
  getTravelPlanFailure,
  clearError,
  clearMessage,
} = getTravelPlanSlice.actions;

export default getTravelPlanSlice.reducer;
